// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getRecentDocuments, RecentDocumentsPayload } from "@conklin/App/Services/RecentDocumentService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

export type RecentDocument = {
    name: string;
    filePath: string;
    description: string;
    erpNumber: string;
    productPathUrl: string;
};

type HandlerType = ApiHandler<RecentDocumentsPayload, RecentDocument[]>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getRecentDocuments(props.apiParameter);
};

export const DispatchCompleteLoadRecentDocuments: HandlerType = props => {
    props.dispatch({
        type: "xRecentDocuments/update",
        documents: props.apiResult,
    } as any);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadRecentDocuments];

const loadRecentDocuments = createHandlerChainRunner(chain, "LoadRecentDocuments");
export { loadRecentDocuments };
